import type { Banner, PointOfInterest } from "../../@types/mapviewxs";
import type { UnHoverItemEvent } from "../left-rail-item/types";

export interface Input {
  feedItems: PointOfInterest[];
  pointsOfInterest: PointOfInterest[];
  prevSelectedItems: number[];
  selectedItems: number[];
  highlightedItem: number | null;
  prevHighlightedItem: number | null;
  showErrorMessage: boolean;
  "on-item-hover"?: (itemIndex: number, listingId?: string) => void;
  "on-unhover-item"?: () => void;
  isWatchlistPillActive?: boolean;
  areFiltersActive?: boolean;
  isLoading?: boolean;
  bannerInsertPositions: number[];
  banners: Banner[];
}

export default class extends Marko.Component<Input> {
  declare wasLoading: boolean;

  onCreate(input: Input) {
    this.wasLoading = input.isLoading || false;
  }

  onMount() {
    // Disable browser's automatic scroll restoration
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }
    // Scroll to top of feed on initial page load
    window.scrollTo(0, 0);
  }

  onInput(input: Input) {
    const isLoading = input.isLoading || false;

    // Scroll to top when loading state changes
    if (this.wasLoading !== isLoading) {
      window.scrollTo(0, 0);
    }

    this.wasLoading = isLoading;
  }

  onItemHover(itemIndex: number, listingId?: string) {
    this.emit("item-hover", itemIndex, listingId);
  }

  onUnhoverItem(e: UnHoverItemEvent) {
    e?.el.parentElement?.querySelectorAll(".items-feed__item")?.forEach((el: HTMLAnchorElement) => el.blur());
    this.emit("unhover-item");
  }
}
